import DOMPurify from 'dompurify';

/**
 * HTML 문자열을 DOMPurify로 sanitize하여 XSS를 방지한다.
 * 검색 하이라이트 등 서버에서 반환하는 HTML을 렌더링할 때 사용.
 *
 * 허용 태그: <mark>, <em>, <strong>, <b>, <i>, <span> (하이라이트 용도)
 * 허용 속성: class (스타일링 용도)
 * 그 외 모든 태그/속성/이벤트 핸들러는 제거됨.
 */
export function sanitizeHtml(dirty: string): string {
  return DOMPurify.sanitize(dirty, {
    ALLOWED_TAGS: ['mark', 'em', 'strong', 'b', 'i', 'span'],
    ALLOWED_ATTR: ['class'],
  });
}
